// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCaseRoleTypeRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentCaseRoleTypeRelationshipModel.attributeTypeMap;
    }
}
EnrollmentCaseRoleTypeRelationshipModel.discriminator = undefined;
EnrollmentCaseRoleTypeRelationshipModel.additionalProperties = false;
EnrollmentCaseRoleTypeRelationshipModel.attributeTypeMap = [
    {
        "name": "roleType",
        "baseName": "roleType",
        "type": "RoleType"
    },
    {
        "name": "caseRelations",
        "baseName": "caseRelations",
        "type": "Array<EnrollmentCaseOrderedRelationshipModel>"
    },
];
//# sourceMappingURL=enrollmentCaseRoleTypeRelationshipModel.js.map